import React, { useMemo } from 'react';
import * as Styled from './Video.styled';
import { getStartTimeInSeconds } from './utils/getStartTimeInSeconds';
import { parseVideoUrl } from './utils/parseVideoUrl';
import { StyledContentContainer } from '../../containers/StyledContentContainer.styled';
import { VideoPlaceholder } from './components/VideoPlaceholder';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Video Block for YouTube and Vimeo videos
 */
export const Video = _ref => {
  let {
    src,
    iframeTitle,
    startTime,
    mute,
    forceShowPlaceholder,
    cssAspectRatio,
    fit = false,
    parentLayoutInfo,
    ...rest
  } = _ref;
  const placeholder = useMemo(() => /*#__PURE__*/_jsx(VideoPlaceholder, {
    alt: iframeTitle,
    fit: fit,
    parentLayoutInfo: parentLayoutInfo
  }), [iframeTitle, fit, parentLayoutInfo]);
  if (!src || forceShowPlaceholder) return placeholder;
  const videoUrlParseObject = parseVideoUrl(src);
  if (!videoUrlParseObject) return placeholder;
  const {
    domain,
    video_id: videoId
  } = videoUrlParseObject;
  if (!videoId) return placeholder;
  const isYouTube = Boolean(domain && (domain === 'youtube.com' || domain === 'youtu.be'));
  const isVimeo = Boolean(domain && domain === 'vimeo.com');
  if (!isYouTube && !isVimeo) return placeholder;
  const startTimeInSeconds = getStartTimeInSeconds(startTime);
  return /*#__PURE__*/_jsx(StyledContentContainer, {
    fit: fit,
    parentLayoutInfo: parentLayoutInfo,
    children: /*#__PURE__*/_jsx(Styled.Iframe, {
      cssAspectRatio: cssAspectRatio,
      src: isYouTube ? `https://www.youtube.com/embed/${videoId}?` +
      // disable "related videos" at end of video
      `rel=0&` + `mute=${mute ? '1' : '0'}&` + `start=${startTimeInSeconds}` :
      // Vimeo
      `https://player.vimeo.com/video/${videoId}?` + `muted=${mute ? '1' : '0'}&` + `#t=${startTimeInSeconds}s`,
      title: iframeTitle,
      allow: "accelerometer; encrypted-media; gyroscope; picture-in-picture;",
      allowFullScreen: true,
      ...rest
    })
  });
};